// export const base_url = "http://13.40.6.124:6479/"
// export const base_url = "https://julie.bhau777.com/"
export const base_url = "https://karyalay.bhau777.com/"
// export const base_url = "http://192.168.1.8:6479/"
export const common_chart_url = "https://resultapi.org/"







